import { Injectable } from '@angular/core';
import {MdDialog, MdDialogConfig, MdSnackBar, MdSnackBarConfig} from '@angular/material';
import {Observable} from 'rxjs/Observable';
import {RestoreItemDialogComponent} from '../../components/restore-item-dialog/restore-item-dialog.component';

@Injectable()
export class RestoreItemService {

    constructor(public dialog: MdDialog, public snackBar: MdSnackBar) { }

    /**
     *
     * @param {string} name Name of the item to delete
     * @param {string} title Title to be displayed at the top of the dialog
     * @param {string} description Description of the consequences for deleting
     * @param {number} id ID of the item to delete
     * @return {Observable<any>} when a user deletes an item
     */
    openDialog(name: string, title: string, description: string, id: number): Observable<number> {
        return this.dialog
            .open(RestoreItemDialogComponent, <MdDialogConfig> {
                // data to be passed in
                data: {
                    name: name,
                    title: title,
                    description: description,
                    id: id
                }
            })
            .afterClosed()
            .skipWhile((value) => value !== id)
            .do(() => this.snackBar.open('Item restored!', 'Dismiss', <MdSnackBarConfig>{duration: 3000}));
    }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/restore-item/restore-item.service.ts